import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { Webform } from '@uncinc/react-drupal-core';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import { APP_OPTIONS } from '../../../config/constants';

import './style.scss';

const BlogSubscribeWidget: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'components.widgets.blog_subscribe_widget' });

  const classes = c('BlogSubscribeWidget', 'Paper');

  return (
    <div className={classes}>
      <h2 className="BlogSubscribeWidget__title asH3">
        {t('title')}
      </h2>

      <WysiwygField
        className="BlogSubscribeWidget__body body--small"
        property="schema:text"
        html={t('body')}
      />

      <Webform
        id={APP_OPTIONS.parameters.blogSubscribeWebformID}
        scrollToTopAfterSubmit={false}
        addFocusOnFirstInvalidField
      />
    </div>
  );
};

export default BlogSubscribeWidget;
